<div>
  <div *ngFor="let item of data">

   <app-public-profile-dynamic-single-form-view [item]="item"></app-public-profile-dynamic-single-form-view>
  </div>
</div>
